import ImageConverterTemplate from "../components/ImageConverterTemplate";

export default function ConvertTiffToBmp() {
  return (
    <ImageConverterTemplate
      sourceFormat="TIFF"
      targetFormat="BMP"
      acceptTypes=".tiff,.tif,image/tiff"
      slug="convert-tiff-to-bmp"
      gradientColors="from-purple-500 to-blue-500"
      accentColor="blue"
    />
  );
}
